/* eslint-disable */

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Divider,
  Grid,
  IconButton,
  List,
  ListItemButton,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { BiDollar } from 'react-icons/bi';
import {
  AddRounded,
  AttachMoneyRounded,
  BusinessRounded,
  EditRounded,
  MonetizationOnRounded,
} from '@mui/icons-material';
import ContractDetails from './ContractDetails';
import palette from '../../../theme/palette';
import Key from '../../../clientVariables.json';
import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import InvioceDetails from './InvioceDetails';

const InvoicesData = () => {
  const styles = useResponsiveStyles();
  const [invoiceData, setInvoiceData] = useState();
  const [invoiceDetails, setInvoiceDetails] = useState();
  const [activeButton, setActiveButton] = React.useState('All');
  const contractsData = useSelector((state) => state.contractsManagement.contracts);
  const selectedContract = useSelector((state) => state.contractsManagement.selectedContract);

  useEffect(() => {
    getInvoices();
  }, []);

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  const getInvoices = async () => {
    try {
      const response = await axios.get(`${Key.domain}/payment/invoices`);
      setInvoiceData(response.data.data);
      getInvoiceDetailsBySubscriptionID(response.data.data[0]?.subscription_id);
    } catch (error) {
      console.error(error);
    }
  };

  const getInvoiceDetailsBySubscriptionID = async(subID) => {
    try {
      const response = await axios.get(`${Key.domain}/payment/invoice/${subID}`);
      setInvoiceDetails(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  const invoiceSelectHandler = (id) => {
    
    getInvoiceDetailsBySubscriptionID(id);
  }


  const getContrastingTextColor = (backgroundColor) => {
    const hexColor = backgroundColor.replace(/^#/, '');
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000000' : '#FFFFFF';
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case 'Paid':
        return { backgroundColor: '#C8E6C9', color: getContrastingTextColor('#C8E6C9') };
      case 'Due':
        return { backgroundColor: '#FFD180', color: getContrastingTextColor('#FFD180') };
      case 'Over Due':
        return { backgroundColor: '#FFAB91', color: getContrastingTextColor('#FFAB91') };
      default:
        return {};
    }
  };
  const renderStatus = (data) => {
    const params = data.paid === 1 ? 'Paid' : (data.paid === 2 ? 'Over Due' : "Due");
    const statusStyles = getStatusStyles(params);

    return (
      <div
        style={{
          ...statusStyles,
          paddingInline: '8px',
          paddingBlock: '2px',
          borderRadius: '4px',
          fontSize: '12px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {params}
      </div>
    );
  };

  const buttonStyles = (buttonName) => ({
    borderRadius: '0px',
    p: '4px 15px',
    color: activeButton === buttonName ? palette.primary.main : palette.grey[600],
    backgroundColor: activeButton === buttonName ? palette.primary.lighter : 'transparent',
    borderColor: palette.grey[400],
    '&:hover': {
      backgroundColor: activeButton === buttonName ? palette.primary.light : palette.primary.lighter,
      //   borderColor: activeButton === buttonName ? 'primary.dark' : 'primary.main',
    },
    fontSize: styles.fontSize12,
  });

  const text1Styles = {
    m: 0,
    fontSize: styles.fontSize12,
    fontWeight: 500,
    color: palette.grey[600],
  };

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} sx={{ mt: '5px' }}>
        <ButtonGroup variant="outlined" aria-label="Basic button group" size="small" sx={{ mb: '6px' }}>
          <Button sx={buttonStyles('All')} onClick={() => handleButtonClick('All')}>
            All
          </Button>
          <Button sx={buttonStyles('Trail Period')} onClick={() => handleButtonClick('Trail Period')}>
            Due
          </Button>
          <Button sx={buttonStyles('Monthly')} onClick={() => handleButtonClick('Monthly')}>
            Paid
          </Button>
          <Button sx={buttonStyles('Yearly')} onClick={() => handleButtonClick('Yearly')}>
            Over Due
          </Button>
        </ButtonGroup>
      </Grid>
      <Grid item xs={3.5}>
        {/* <Divider /> */}
        <Paper elevation={1} sx={{height: window.innerHeight - 100, overflow: 'scroll' }}>
          <List sx={{ pr: '4px' }}>
            {invoiceData?.map((data, index) => (
              <ListItemButton
                  onClick={() => invoiceSelectHandler(data?.subscription_id)}
                  selected={invoiceDetails?.invoice_number === data?.invoice_number}
                sx={{
                  borderBottom: '1px solid #ddd',
                  '.editButton': {
                    display: 'none',
                  },
                  '&:hover': {
                    '.editButton': {
                      display: 'block',
                    },
                  },
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                  <Box sx={{ display: 'flex', gap: '6px' }}>
                    <Avatar>
                      <BiDollar />
                    </Avatar>
                    <Box sx={{ width: '100', flexGrow: 1 }}>
                      <Box sx={{ display: 'flex', width: '100%' }}>
                        <Typography
                          paragraph
                          sx={{
                            flexGrow: 1,
                            m: 0,
                            fontWeight: 800,
                            fontSize: styles.fontSize16,
                            color: palette.grey[800],
                            textTransform: 'capitalize',
                          }}
                        >
                          {data?.company_name}
                        </Typography>
                        {/* <Tooltip title="Edit Contract" followCursor>
                        <EditRounded
                          className="editButton"
                          // onClick={() => setEditCustomerData(data)}
                          sx={{
                            height: styles.icon20,
                            width: styles.icon20,
                            color: palette.grey[600],
                            bgcolor: '#fff',
                          }}
                        />
                      </Tooltip> */}
                      </Box>
                      {/* <Typography paragraph sx={{...text1Styles}}>
                      California City, California
                  </Typography> */}
                      <Typography paragraph sx={{ ...text1Styles }}>
                        {data?.email}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Invoice No.
                      </Typography>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                        {data?.invoice_number}
                      </Typography>
                    </Box>
                    <Box sx={{ border: '1px solid #ddd' }} />
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Status
                      </Typography>
                      {/* <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                      pending
                    </Typography> */}
                      {renderStatus(data)}
                    </Box>
                    <Box sx={{ border: '1px solid #ddd' }} />
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Amount
                      </Typography>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                        ${data?.price}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </ListItemButton>
            ))}
          </List>
        </Paper>
      </Grid>
      <Grid item xs={8.5}>
        <InvioceDetails invoiceDetails={invoiceDetails} />
      </Grid>
    </Grid>
  );
};

export default InvoicesData;
